import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cls from "./ServicesSection.module.scss";
import CheckIcon from "../../../shared/ui/CheckIcon/CheckIcon";
const services = [
    {
        title: "Performance Marketing",
        description: "ROI-driven CPA campaigns built to increase conversions and revenue.",
    },
    {
        title: "Traffic Acquisition",
        description: "High-quality, targeted traffic from leading platforms such as Google Ads, Meta, TikTok, and more.",
    },
    {
        title: "Strategy & Creative Development",
        description: "Compelling ad creatives and conversion funnels designed to engage, persuade, and perform.",
    },
    {
        title: "Analytics & Optimization",
        description: "End-to-end tracking, testing, and continuous optimization powered by data and A/B experiments.",
    },
];
export default function ServicesSection() {
    return (_jsx("section", { id: "services", className: cls.section, children: _jsx("div", { className: cls.container, children: _jsxs("div", { className: cls.grid, children: [_jsx("div", { className: cls.imageWrapper, children: _jsx("img", { src: "/images/services-image.png", alt: "Team analyzing data and analytics", className: cls.image }) }), _jsxs("div", { className: cls.content, children: [_jsx("h2", { className: cls.title, children: "Smarter advertising. Stronger results." }), _jsx("div", { className: cls.list, children: services.map((service, index) => (_jsxs("div", { className: cls.item, children: [_jsx("div", { className: cls.checkIcon, children: _jsx(CheckIcon, {}) }), _jsxs("div", { className: cls.itemContent, children: [_jsx("h3", { className: cls.itemTitle, children: service.title }), _jsx("p", { className: cls.itemDescription, children: service.description })] })] }, index))) })] })] }) }) }));
}
